import type { Pergunta } from './dados';
import { ESCALAS } from './dados';

interface PreviaWhatsAppProps {
  /** Nome do titular do mandato (ex.: "Ana Silva"), vindo de `adminApi.getMandato`. */
  nomeTitular: string;
  /** Cargo do titular (ex.: "Vereadora"), vindo de `adminApi.getMandato`. */
  cargoTitular: string;
  /** Nome do território, quando o modo de público é "Só um bairro". */
  nomeLocalidade?: string;
  objetivo: string;
  perguntasAtivas: Pergunta[];
}

/**
 * Prévia da primeira mensagem do questionário no WhatsApp — proto:1631
 * (`<div class="wa"><div class="bub">...`). Só renderização: nada aqui
 * dispara mensagem real.
 */
export function PreviaWhatsApp({
  nomeTitular,
  cargoTitular,
  nomeLocalidade,
  objetivo,
  perguntasAtivas,
}: PreviaWhatsAppProps) {
  const primeira = perguntasAtivas[0];
  const opcoes = primeira ? primeira.opts || ESCALAS[primeira.e] : [];

  return (
    <div className="card" data-testid="previa-whatsapp">
      <h2>Prévia no WhatsApp</h2>
      <div className="wa">
        <div className="bub">
          Olá, {'{{primeiro_nome}}'}! {cargoTitular || 'A vereadora'} {nomeTitular} quer ouvir{' '}
          {nomeLocalidade || 'você'} sobre {objetivo.slice(0, 40) || 'o assunto da campanha'}. São{' '}
          {perguntasAtivas.length} perguntas rápidas, responda com o número:
          <br />
          <br />
          1) {primeira ? primeira.q : ''}
          <br />
          {opcoes.map((o, i) => `${i + 1} ${o}`).join('  ')}
          <br />
          <br />
          Responda SAIR para não receber mais mensagens.
        </div>
        <small>09:00 ✓✓</small>
      </div>
      <p style={{ fontSize: 12, color: 'var(--ink3)', margin: '8px 0 0' }}>
        Uma pergunta por mensagem, com botões (até 3) ou lista; as demais seguem conforme a pessoa
        responde. Modelo utility aprovado na Meta.
      </p>
    </div>
  );
}
